import { ScrollView, ScrollViewProps, styled, View } from "tamagui";

import { stylex } from "../../utils";

const PageContainer = styled(View, {
  name: "PageContainer",
  width: "100wv",
  minHeight: "100dvh",
  position: "relative",
  flexDirection: "row",
  flex: 2,
});

const ContentContainer = styled(View, {
  name: "ContentContainer",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  overflow: "hidden",
});

const InnerScroll = styled(ScrollView, {
  flexGrow: 1,
  contentContainerStyle: {
    minHeight: "100dvh",
    alignSelf: "center",
    width: "100%",
  },
});

type LayoutProps = React.ComponentProps<typeof ContentContainer> & {
  variant?: "monobackground" | "dualbackground";
  mode?: "tutorial" | "default";
  scrollProps?: ScrollViewProps;
};

export const Layout: React.FC<LayoutProps> = ({
  variant = "monobackground",
  mode,
  children,
  scrollProps,
  ...rest
}) => {
  return (
    <PageContainer>
      <View
        flex={1}
        $sm={{ flex: 2 }}
        backgroundColor={"white"}
        {...stylex([variant === "monobackground", { flex: 2 }])}
      />
      <View
        flex={1}
        $sm={{ display: "none" }}
        backgroundColor={
          mode === "tutorial" ? "$lightpink-500" : "$bgpeach-500"
        }
        {...stylex([variant === "monobackground", { display: "none" }])}
      />
      <ContentContainer {...rest}>
        <InnerScroll
          {...scrollProps}
          contentContainerStyle={scrollProps?.contentContainerStyle}
        >
          {children}
        </InnerScroll>
      </ContentContainer>
    </PageContainer>
  );
};
